import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { SchedulingTask, TaskTypeEnum } from './../interfaces/SchedulingTask';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { url } from "inspector";
import { Observable } from "rxjs";
import { AppConfig } from "src/app/core/_config/app.config";
import { CustomResponse } from "../interfaces/CustomResponse";
import { PaginationResult } from "../interfaces/PaginationResult";
import { RecurringInstallmentsOnCard } from "../models/RecurringInstallmentsOnCard";

@Injectable({
  providedIn: "root",
})
export class SchedulingTaskService {
  private API_URL = this.config.urlApi + this.config.versionApi;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) { }

  getAll(): Observable<ResponseCustom> {
    return this.http.get<ResponseCustom>(`${this.API_URL}SchedulingTask`, { headers: this.headers });
  }

  exist(params: any): Observable<any> {
    return this.http.head(`${this.API_URL}SchedulingTask`, { headers: this.headers, params: params });
  }

  getTypes(): Observable<TaskTypeEnum[]> {
    return this.http.get<TaskTypeEnum[]>(`${this.API_URL}SchedulingTask/Types`, { headers: this.headers });
  }

  saveNew(task: SchedulingTask): Observable<any> {
    return this.http.post<any>(`${this.API_URL}SchedulingTask`, task, { headers: this.headers });
  }

  updateTask(task: SchedulingTask): Observable<any> {
    return this.http.put<any>(`${this.API_URL}SchedulingTask/${task.id}`, task, { headers: this.headers });
  }

  runTask(id): Observable<any> {
    return this.http.post<any>(`${this.API_URL}SchedulingTask/${id}/Run`, { headers: this.headers });
  }
}
